"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegulatoryAssessmentsDto = instanceOfRegulatoryAssessmentsDto;
exports.RegulatoryAssessmentsDtoFromJSON = RegulatoryAssessmentsDtoFromJSON;
exports.RegulatoryAssessmentsDtoFromJSONTyped = RegulatoryAssessmentsDtoFromJSONTyped;
exports.RegulatoryAssessmentsDtoToJSON = RegulatoryAssessmentsDtoToJSON;
exports.RegulatoryAssessmentsDtoToJSONTyped = RegulatoryAssessmentsDtoToJSONTyped;
const RegulatoryAssessmentDto_1 = require("./RegulatoryAssessmentDto");
/**
 * Check if a given object implements the RegulatoryAssessmentsDto interface.
 */
function instanceOfRegulatoryAssessmentsDto(value) {
    if (!('assessments' in value) || value['assessments'] === undefined)
        return false;
    return true;
}
function RegulatoryAssessmentsDtoFromJSON(json) {
    return RegulatoryAssessmentsDtoFromJSONTyped(json, false);
}
function RegulatoryAssessmentsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'renewalOpensAt': json['renewalOpensAt'] == null ? undefined : (new Date(json['renewalOpensAt'])),
        'assessments': (json['assessments'].map(RegulatoryAssessmentDto_1.RegulatoryAssessmentDtoFromJSON)),
    };
}
function RegulatoryAssessmentsDtoToJSON(json) {
    return RegulatoryAssessmentsDtoToJSONTyped(json, false);
}
function RegulatoryAssessmentsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'expiresAt': value['expiresAt'] == null ? undefined : (value['expiresAt'].toISOString()),
        'renewalOpensAt': value['renewalOpensAt'] == null ? undefined : (value['renewalOpensAt'].toISOString()),
        'assessments': (value['assessments'].map(RegulatoryAssessmentDto_1.RegulatoryAssessmentDtoToJSON)),
    };
}
//# sourceMappingURL=RegulatoryAssessmentsDto.js.map